// extracted by mini-css-extract-plugin
module.exports = {"inline":"ManagedBadge_inline__HtA7W","dividerDot":"ManagedBadge_dividerDot__Qw10Q","mobile":"ManagedBadge_mobile__5Wa6l"};